import { SignalPriorityLevel } from "../../../List/schema/list";

/** The `leadScoring.changeLog.priority.*` key for a stored overall score. */
export const priorityLabelKey = (level: string | null | undefined): string => {
	switch ((level ?? "").toLocaleLowerCase()) {
		case SignalPriorityLevel.PRIORITY_1:
			return "priority_1";
		case SignalPriorityLevel.PRIORITY_2:
			return "priority_2";
		case SignalPriorityLevel.PRIORITY_3:
			return "priority_3";
		case SignalPriorityLevel.DISQUALIFIED:
			return "disqualified";
		default:
			return "unknown";
	}
};

/** The pill colours of a priority, from the same tokens the lead card uses. */
export const priorityClassName = (level: string | null | undefined): string => {
	switch ((level ?? "").toLocaleLowerCase()) {
		case SignalPriorityLevel.PRIORITY_1:
			return "bg-background-success border border-text-success text-text-success";
		case SignalPriorityLevel.PRIORITY_2:
			return "bg-background-warning border border-text-warning text-text-warning";
		case SignalPriorityLevel.PRIORITY_3:
			return "bg-error-light border border-error text-error";
		case SignalPriorityLevel.DISQUALIFIED:
			return "bg-error text-white border border-error";
		default:
			return "bg-background-light text-text-meta";
	}
};
